import { Component, h, ComponentInterface } from '@stencil/core';

@Component({
	tag: 'kdx-blog-listing',
	styleUrl: 'kdx-blog-listing.scss',
	shadow: false
})
export class StBlogListing implements ComponentInterface {

	render() {
		return (
			<section class="kdx-blog-listing" aria-label="blog listing">
				<slot />
			</section>
		);
	}
}